import { Container, Row, Col } from 'react-bootstrap';

export function Footer() {
	return (
		<>
			<Container className="dark-bg text-white m-0" fluid>
				<Container className="app-container extra-padding">
					<Row>
						<Col className=" map-bg" xs={12} md={4}>
							<p className="text-light">
								<strong className="d-block mb-2">
									<i className="bi bi-map mr-2" />
									Office:
								</strong>
								<a
									style={{ color: '#ccc' }}
									href="https://goo.gl/maps/9WcUVYf5jUrRiwq69">
									100 East Center Street
									<br />
									Suite 1200
									<br />
									Provo, Utah 84606
									<br />
								</a>
							</p>

							<p className="text-light">
								<strong className="d-block mb-1">
									<i className="bi bi-telephone mr-2" />
									Phone:{' '}
									<a style={{ color: '#ccc' }} href="tel:+18018518255">
										(801) 851-8255
									</a>
								</strong>
								<strong className="d-block mb-1">
									<i className="bi bi-printer mr-2" />
									Fax:{' '}
									<a style={{ color: '#ccc' }} href="tel:+18018518265">
										(801) 851-8265
									</a>
								</strong>
								<strong className="d-block">
									<i className="bi bi-envelope mr-2" />
									Email:{' '}
									<a
										style={{ color: '#ccc' }}
										href="mailto:UCFM@utahcounty.gov">
										UCFM@utahcounty.gov
									</a>
								</strong>
							</p>

							<strong>Hours:</strong>
							<p style={{ color: '#ccc' }}>
								Monday - Friday
								<br />
								8:00am - 5:00pm
							</p>
						</Col>

						<Col xs={12} md={4}>
							<strong>Popular Links:</strong>
							<ul className="list-unstyled ">
								<li className="my-2">
									<a
										style={{ color: '#ccc' }}
										href="https://www.utahcounty.gov/Dept/FireMarshal/Burn_q.asp">
										Burn Notice Form
									</a>
								</li>
								<li className="my-2">
									<a
										style={{ color: '#ccc' }}
										href="https://www.utahcounty.gov/LocalInfo/Cities.asp">
										Cities in Utah County
									</a>
								</li>
							</ul>
						</Col>

						<Col xs={12} md={4}>
							<strong>OTHER WEBSITES:</strong>
							<ul className="list-unstyled ">
								<li className="my-2">
									<a
										style={{ color: '#ccc' }}
										href="https://www.weather.gov/slc/ClearingIndex#tab-3">
										Utah Division of Air Quality Burn Clearing Index
									</a>
								</li>
								<li className="my-2">
									<a
										style={{ color: '#ccc' }}
										href="https://firemarshal.utah.gov/">
										Utah State Fire Marshal
									</a>
								</li>
							</ul>
						</Col>
					</Row>
				</Container>
			</Container>
			<Container className="darker-bg text-white m-0 py-1" fluid>
				<Container className="app-container">
					<Row>
						<Col className="d-flex justify-content-center" xs={12} md={6}>
							<p className="text-light m-0 text-center">
								Copyrights © 2021 All Rights Reserved by Utah County Treasurer
								<br />
								<a
									className="text-light text-center"
									href="https://www.utahcounty.gov/disclaimer.html">
									Terms of Use
								</a>
								{' / '}
								<a
									className="text-light text-center"
									href="https://www.utahcounty.gov/disclaimer.html">
									Privacy Policy
								</a>
							</p>
						</Col>
						<Col className="d-flex justify-content-center" xs={12} md={6}>
							<p className="text-center m-0">
								<a
									className="text-light"
									href="https://www.utahcounty.gov/disclaimer.html">
									Utah County Fire Marshal
								</a>
								{' - '}
								<a className="text-light" href="tel:+18018518255">
									(801) 851-8255
								</a>
							</p>
						</Col>
					</Row>
				</Container>
			</Container>
		</>
	);
}
